import CommonImage from "@/components/common/image/CommonImage";
import React from "react";

export default function Routine({ course }) {
  // console.log("course", course);

  return (
    <div className="routine_section">
      <div className="title-area">
        <h2 className="title">রুটিন</h2>
        <a
          href={course?.routine_url}
          target="_blank"
          rel="noopener noreferrer"
          className="primary-btn"
          download
        >
          ডাউনলোড করো
        </a>
      </div>
      <div className="routine_card">
        {/* {course?.routine_url &&
         <iframe
          src={course.routine_url}
          title="Routine PDF"
          width="100%"
          height="600px"
          style={{ border: 'none' }}
        />
        } */}

        <CommonImage
          src={
            course?.routine_image_url ?? "/images/course-img/routine-image.avif"
          }
          className="routine-img"
          alt="routine Img"
        />
      </div>
    </div>
  );
}
